module.exports = __webpack_public_path__ + "static/img/压路机.ada8939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/type-1/压路机.png
// module id = nwUK
// module chunks = 0